import * as TabsPrimitive from '@radix-ui/react-tabs';

import { forwardRef } from 'react';
import { cn } from '../../util';

const TabsList = forwardRef<
  React.ComponentRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'bg-muted text-muted-foreground inline-flex h-11 items-center justify-center rounded-lg p-1.5',
      className
    )}
    {...props}
  />
));

TabsList.displayName = TabsPrimitive.List.displayName;

export default TabsList;
